import { language, localesWithEnglishAddress } from '../../../constants';

const collapseSpaces = (text) => text.replace(/\s+/g, ' ').trim();

const getLocalisedAddress = ({ address = {}, locale }) => (
  localesWithEnglishAddress.includes(locale)
    ? address.en
    : address[locale] || address[language.default]
) || {};

const buildPropertyHeading = ({ propertyType, searchOption, address, locale, translate }) => {
  const { city_name: city, neighborhood } = getLocalisedAddress({ address, locale });
  const location = [city, neighborhood !== city && neighborhood].filter(Boolean).join(', ');
  const optionLabel = translate('propertyDetails', 'SEOTitle', searchOption);
  const prepositionLabel = translate('propertyDetails', 'SEOTitle', 'in');

  const kind = [propertyType, optionLabel].filter(Boolean).join(' ');
  const place = location ? `${prepositionLabel}${location}` : '';

  return collapseSpaces(`${kind} ${place}`);
};

export default buildPropertyHeading;
